import React from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { setupIonicReact } from '@ionic/react';

import App from './App';

/* Core CSS required for Ionic components */
import '@ionic/react/css/core.css';
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Leaflet CSS */
import 'leaflet/dist/leaflet.css';

/* Theme */
import './theme/variables.css';
import './theme/crm.css';
import './theme/roster-console.css';
import './theme/my-groups.css';
import './theme/scope-dialog.css';
import './theme/attendance-pulse.css';
import './theme/calendar.css';
import './theme/scheduling.css';
import './theme/communion-live.css';
import './theme/kindergarten.css';
import './theme/kindergarten-families.css';
import './theme/kindergarten-finance.css';
import './theme/kindergarten-reports.css';

setupIonicReact({
  mode: 'md',
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 2 * 60 * 1000,    // Data stays fresh for 2 minutes
      gcTime: 10 * 60 * 1000,      // Cache kept for 10 minutes after unmount
      retry: 1,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
    },
    mutations: {
      retry: 0,
    },
  },
});

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element not found');
}

const root = createRoot(container);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
